import { useState, useEffect } from "react";
import classnames from "classnames";
import useSWR from "swr";
import Card from "components/global/card";
import { formatNumber } from "utils/intl";

import PARKS_QUERY from "queries/parks";

export default function Parks() {
  const [currentPage, setCurrentPage] = useState(1);
  const [nbPages, setNbPages] = useState(0);

  const perPage = 30;
  const startRange = perPage * (currentPage - 1);
  const variables = {
    limit: perPage,
    start: startRange,
  };

  const { data, error } = useSWR([PARKS_QUERY, variables]);

  if (error) {
    console.error(error);
  }

  useEffect(() => {
    setNbPages(Math.max(data?.parksCount / perPage));
  }, [data?.parksCount]);

  if (!Array.isArray(data?.parks)) {
    return null;
  }

  return (
    <>
      <p className="mb-3 text-gray-700">
        Showing{" "}
        <span className="font-mono">
          {formatNumber(startRange + 1)}-
          {formatNumber(Math.min(startRange + perPage, data?.parksCount))}
        </span>{" "}
        of <span className="font-mono">{formatNumber(data?.parksCount)}</span>
      </p>
      <div className="mb-10 space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0">
        {data?.parks?.map((park) => (
          <Card
            link={`/park/${park.Slug}`}
            title={park.Name}
            image={park.MainPhoto}
            type="park"
            isTempClosed={park.IsTempClosed}
            key={`park-${park.id}`}
            location={park.Location}
          />
        ))}
      </div>
      <ul className="flex justify-center">
        <li
          className={classnames(
            "mx-1 select-none rounded-lg px-3 py-2",
            currentPage === 1
              ? "bg-indigo-100 text-gray-500"
              : "bg-indigo-900 text-white"
          )}
          key="pagination-previous"
        >
          <button
            type="button"
            className={classnames(
              "flex items-center font-bold",
              currentPage === 1 ? "cursor-default" : ""
            )}
            onClick={(event) => {
              event.preventDefault();
              if (currentPage === 1) {
                return false;
              }
              setCurrentPage(currentPage - 1);
              window.scroll(0, 0);
            }}
          >
            <span className="mx-1">previous</span>
          </button>
        </li>
        <li
          className={classnames(
            "mx-1 select-none rounded-lg px-3 py-2",
            currentPage >= nbPages
              ? "bg-indigo-100 text-gray-500"
              : "bg-indigo-900 text-white"
          )}
        >
          <button
            type="button"
            className={classnames(
              "flex items-center font-bold",
              currentPage >= nbPages ? "cursor-default" : ""
            )}
            onClick={(event) => {
              event.preventDefault();
              if (currentPage >= nbPages) {
                return false;
              }
              setCurrentPage(currentPage + 1);
              window.scroll(0, 0);
            }}
          >
            <span className="mx-1">next</span>
          </button>
        </li>
      </ul>
    </>
  );
}
